
  import { defineComponent, onUnmounted } from 'vue';
  import { Button } from '@/ui/components/Button';
  import RRule from '@/ui/components/rrule/RRule.vue';
  import ChooseUserFieldWithSelectAll from '@/ui/components/user/ChooseUserFieldWithSelectAll.vue';
  import { useSchedule } from '@/ui/concerns/analytics/useSchedule';
  import { Loader } from '@/ui/components/Loader';
  import { validate } from '@/entities/analytics-schedule';
  import { storeToRefs } from 'pinia';
  import { useValidation } from '@/ui/concerns';
  import { Days } from '@/entities/rrule/constants';
  import SidebarHeader from '@/ui/components/analytics/sidebar/SidebarHeader.vue';

  interface AnalyticsSendSidebarProps {
    isOpen: boolean;
    scheduleId?: number|null;
    disableAll: boolean;
  }

  export default defineComponent<AnalyticsSendSidebarProps>({
    components: {
      SidebarHeader,
      Loader,
      Button,
      RRule,
      ChooseUserFieldWithSelectAll,
    },
    props: ['isOpen', 'disableAll', 'scheduleId'],
    setup(props, context) {
      const {
        store,
        assigneeOptions,
        getTask,
        refreshUserOptions,
      } = useSchedule(props.scheduleId);

      const { record } = storeToRefs(store);

      onUnmounted(() => store.$reset());

      const {
        validationErrors,
        hasNoValidationErrors,
        showValidationErrors,
      } = useValidation(validate, record);

      const onSave = () => {
        showValidationErrors.value = true;
        if (hasNoValidationErrors.value) {
          context.emit('saved');
        }
      };

      const onClose = () => {
        context.emit('close');
      };

      const onClearAll = () => {
        showValidationErrors.value = false;
        store.$reset();
        context.emit('cleared');
      };

      const updateDay = (v: { value: boolean; day: Days }) => {
        store.changeDay(v.value, v.day);
      };

      return {
        ...store,
        schedule: record,
        updateDay,
        getTask,
        users: assigneeOptions,
        validationErrors,
        onSave,
        onClose,
        onClearAll,
        refreshUserOptions,
      };
    },
  });
